import { defineMessages } from 'react-intl'

const scope = 'app.components.LicenseTooltip'

export default defineMessages({
  license: {
    id: `${scope}.license`,
    defaultMessage: 'License',
  },
  rows: {
    licenseName: {
      id: `${scope}.rows.licenseName`,
      defaultMessage: 'License Name',
    },
    licenseNumber: {
      id: `${scope}.rows.licenseNumber`,
      defaultMessage: 'License Number',
    },
    type: {
      id: `${scope}.rows.type`,
      defaultMessage: 'License Type',
    },
    dbaName: {
      id: `${scope}.rows.dbaName`,
      defaultMessage: 'DBA or Trade Name',
    },
    date: {
      id: `${scope}.rows.date`,
      defaultMessage: 'License Expiration Date',
    },
    licenseRegisteredAddress: {
      id: `${scope}.rows.licenseRegisteredAddress`,
      defaultMessage: 'Registered Address',
    },
  },
})
